<div class="parallax" *ngIf="menucategories.length > 0">
    <div class="title">
        <h3>
            <strong>Nos Menus</strong>
        </h3>
    </div>
    <div class="container">
        <div *ngIf="loading" id="loadingPage"></div>
        <div class="families" *ngIf="!loading">
            <a routerLink="/carte/menus/{{menu?.slug}}" *ngFor="let menu of menucategories"
                class="families__item">
                <div class="families__item--family"> {{menu?.name}}</div>
                <div class="families__item--img">
                    <div class="loadingAvatar" *ngIf="!loadAvatar"></div>
                    <img [class.v-hidden]="!loadAvatar" appLazyLoad (load)="loadAvatar=true"
                        [src]="menu?.avatar|absolutePath:'families'" title="Livraison {{city}} {{menu?.name}}"
                        alt="Livraison {{city}} {{menu?.name}}">
                </div>
            </a>
        </div>
    </div>
</div>